/* eslint @typescript-eslint/no-var-requires:  "off" */
import * as React from 'react';
import { DappUI, logout, useGetAccountInfo } from '@elrondnetwork/dapp-core';
import { contractAddress } from 'config';
import { routeNames } from 'routes';
import Reactn, { useState, useEffect } from 'react';
import { isTemplateExpression } from 'typescript';
import './gallery.css';
import myData from './Backgrounds.json';
import axios from 'axios';

const Gallery = () => {
  const [resultArray, setResultArray] = useState([]);
  const { address, account } = useGetAccountInfo();
  const isLoggedIn = Boolean(address);
  const data: { id: number; ticker: string; name: string; imgSrc: string }[] =
    [];
  Object.keys(myData).forEach(function (key: any) {
    data.push(myData[key]);
  });

  const temp_address =
    'erd1tdyjjugnfv6c7gzn2ydmgu4wztsdcxsqmfkmf7avr6yq074eqhsst5tzre';

  useEffect(() => {
    const expensesListResp = async () => {
      const url =
        'https://api.elrond.com/accounts/' +
        address +
        '/nfts?type=SemiFungibleESDT&collection=SRB-0f1b1d';
      await axios.get(url).then((response) => setResultArray(response.data));
    };
    expensesListResp();
  }, []);

  function SingleSFT(props: any) {
    let has = false;
    let i;
    for (i = 0; i < resultArray.length; i++) {
      if (resultArray[i]['identifier'] === props.sft.ticker) {
        has = true;
        console.log(props.sft.name);
      }
    }
    return (
      <li>
        <div className='img-wrapper'>
          {!has ? (
            <a
              href={'https://deadrare.io/nft/' + props.sft.ticker}
              rel='noreferrer'
              target='_blank'
            >
              <div className='img-overlay'>
                <p>GET</p>
              </div>
            </a>
          ) : null}
          <img className='backgroundsft' src={props.sft.imgSrc} alt='row' />
        </div>
        <h3
          className='name'
          style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
        >
          {props.sft.name}
        </h3>
      </li>
    );
  }

  return (
    <div className='mb-1'>
      <h1
        className='rarity text-center'
        style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
      >
        Legendary
      </h1>
      <div className='gallery  text-center'>
        <div className='serv'>
          <ul>
            {data.map((item, index) => {
              if (item.id >= 1 && item.id <= 6) {
                return <SingleSFT sft={item} />;
              }
            })}
          </ul>
        </div>
      </div>
      <h1
        className='rarity text-center'
        style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
      >
        Epic
      </h1>
      <div className='gallery  text-center'>
        <div className='serv'>
          <ul>
            {data.map((item, index) => {
              if (item.id >= 7 && item.id <= 14) {
                return <SingleSFT sft={item} />;
              }
            })}
          </ul>
        </div>
      </div>
      <h1
        className='rarity text-center'
        style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
      >
        Rare
      </h1>
      <div className='gallery  text-center'>
        <div className='serv'>
          <ul>
            {data.map((item, index) => {
              if (item.id >= 15 && item.id <= 23) {
                return <SingleSFT sft={item} />;
              }
            })}
          </ul>
        </div>
      </div>
      <h1
        className='rarity text-center'
        style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
      >
        Uncommon
      </h1>
      <div className='gallery  text-center'>
        <div className='serv'>
          <ul>
            {data.map((item, index) => {
              if (item.id >= 24 && item.id <= 30) {
                return <SingleSFT sft={item} />;
              }
            })}
          </ul>
        </div>
      </div>
      <h1
        className='rarity text-center'
        style={{ fontFamily: 'Arial', fontWeight: 'bolder' }}
      >
        Common
      </h1>
      <div className='gallery  text-center'>
        <div className='serv'>
          <ul>
            {data.map((item, index) => {
              if (item.id >= 31 && item.id <= 42) {
                return <SingleSFT sft={item} />;
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
